import React from "react";
import {
  Dialog,
  DialogProps,
  Box,
  Typography,
  DialogContent,
  useTheme,
} from "@mui/material";
import { BrandedAppStatus } from "@growth-machine-llc/stridist-api-client";
import { AppLogo } from "../../app/AppLogo";
import EmptyActivitiesArt from "../../../icons/EmptyActivitiesArt";
import { useCurrentBrand } from "../../../hooks/useCurrentWorkspace";

export interface BrandedAppNotPublishedDialogProps extends DialogProps {}

export function BrandedAppNotPublishedDialog(
  props: BrandedAppNotPublishedDialogProps,
) {
  const { className, onClose, ...other } = props;
  const { brandName, brandedAppLogo, brandedAppStatus } = useCurrentBrand();
  const theme = useTheme();

  const isCancelled = brandedAppStatus === BrandedAppStatus.Cancelled;

  return (
    <Dialog
      PaperProps={{ sx: { width: 1, maxWidth: 500 } }}
      componentsProps={{
        backdrop: {
          sx: {
            backdropFilter: "blur(3px)",
          },
        },
      }}
      {...other}
    >
      <DialogContent
        sx={{
          display: "flex",
          alignItems: "center",
          flexDirection: "column",
          textAlign: "center",
          padding: 3,
          paddingTop: 4,
        }}
      >
        {brandedAppLogo ? (
          <Box
            component={"img"}
            sx={{
              width: 80,
              height: 80,
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              borderRadius: "20%",
              boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)",
            }}
            src={brandedAppLogo}
          />
        ) : (
          <AppLogo main full size={80} width={80} />
        )}
        <Box
          sx={{
            width: "100%",
            maxWidth: "300px",
            height: "auto",
            marginY: 3,
          }}
        >
          <EmptyActivitiesArt fill={theme.palette.primary.main} />
        </Box>
        {isCancelled ? (
          <>
            <Typography variant="h6" gutterBottom>
              {brandName} App No Longer Available
            </Typography>
            <Typography variant="body1" color="text.secondary" gutterBottom>
              The {brandName} app is no longer available. Please contact your
              coach for more information.
            </Typography>
          </>
        ) : (
          <>
            <Typography variant="h6" gutterBottom>
              {brandName} App Coming Soon!
            </Typography>
            <Typography variant="body1" color="text.secondary" gutterBottom>
              We are working on publishing {brandName} app for you. Please check
              back later!
            </Typography>
            <Typography
              variant="body2"
              color="text.secondary"
              sx={{ mt: 2, fontStyle: "italic" }}
            >
              You'll be notified when the app is ready for download.
            </Typography>
          </>
        )}
      </DialogContent>
    </Dialog>
  );
}
